import { DrawerContainerComponent } from './drawer-container.component';
import { DrawerContentComponent } from './drawer-content.component';
import { DrawerComponent, DrawerLeftDirective, DrawerRightDirective } from './drawer.component';

export const DrawerImports = [DrawerComponent, DrawerContentComponent, DrawerContainerComponent, DrawerLeftDirective, DrawerRightDirective];
